<template lang="pug">
  include ../../../../../pug/mixins/bem
  div
    +b.poll-title.H1 {{ _('Які продукти ви уже ввели в прикорм своєму малюку?') }}
    +b.poll-text--bold.P {{ _('Ви можете обрати декілька варіантів відповіді.') }}
    +b.poll-products 
      +e.el(
        :class='{"is-disabled": item.is_disabled}'
        v-for='item in products'
      )
        +e.input.INPUT(
          :disabled='item.is_disabled'
          type='checkbox',
          name='products',
          :value='item.key',
          :id='item.key'
          @change='check(item)'
          v-model='product'
        )
        +e.label.LABEL(
          :for='item.key'
          
        )
          +e.icon.SPAN(
            :class='[`svgicon-${item.img}`]'
          )
          +e.text.P  {{ item.title }} 
    +b.poll-btn.BUTTON(
      href='',
      :class='{"is-disabled": !product.length}'
      @click.prevent='next'
    ) {{ _('Далі') }}
  
</template>

<script>
export default {
  name: 'Products',
  data() {
    return {
      product: [],
      products: [
        {
          title: this._('Ще не вводили прикорм '),
          img: 'without_pricorm',
          key: 'without_pricorm',
          clear: true,
          is_disabled: false,
        },
        {
          title: this._('Каша'),
          img: 'kasha',
          key: 'is_porridge',
          is_disabled: false,
        },
        {
          title: this._('Пюре'),
          img: 'pure',
          key: 'is_puree',
          is_disabled: false,
        },
        {
          title: this._('Печиво'),
          img: 'biscuit',
          key: 'is_biscuit',
          is_disabled: false,
        },
        {
          title: this._('Вермішелька'),
          img: 'pasta',
          key: 'is_paste',
          is_disabled: false,
        },
      ]
    }
  },
  methods: {
    check(item) {
      if (item.clear && this.product.find(i => i == item.key)) {
        this.products.forEach(el => {
          el.is_disabled = true
          if (el.clear) el.is_disabled = false
        })
        return
      }
      if (this.product.length) {
        this.products.forEach(el => {
          el.is_disabled = false
          if (el.clear) el.is_disabled = true
        })
        return
      }
      this.products.forEach(el => {
        el.is_disabled = false
      })
    },
    next() {
      let obj = {
        current: 'Form'
      }
      this.products.forEach(element => {
        obj[element.key] = this.product.includes(element.key)
      })
      if (this.product.includes('is_porridge')) {
        obj.current = 'Brands'
      }
      this.$emit('next', obj)
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/poll/steps/products.vue